import { render } from "./TablaProductos.vue?vue&type=template&id=26e6c531&scoped=true"
import script from "./TablaProductos.vue?vue&type=script&lang=js"
export * from "./TablaProductos.vue?vue&type=script&lang=js"

import "./TablaProductos.vue?vue&type=style&index=0&id=26e6c531&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e6c531"]])

export default __exports__